import { render } from "./Konndummy.vue?vue&type=template&id=9aed90e8"
import script from "./Konndummy.vue?vue&type=script&lang=js"
export * from "./Konndummy.vue?vue&type=script&lang=js"

import exportComponent from "/home/cellposition/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__